import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';


const StudentSubject = ({ subject, color }) => {

    let classColor = "card bg-gradient-" + color;
    let classButton = "primary  bg-gradient-" + color + " border border-0 rounded-pill"

  return (

    <div className="card99">
      <div className={classColor}>
          <div className="card-body">
            <div className="row ">
                <div className="col centerCard111 ">
                <span className="h2 font-weight-bold text-white centerCard1"  style={{textTransform: 'capitalize'}}>
                <span className="studenT">{subject.tittle}</span>
                  </span>
                <p className="card-text  navText2 studentsSubj" style={{textTransform: 'capitalize'}}>
                <span className="studenT2">Teacher: {subject.teacherName} </span>
                </p>
                </div>
                <div className="col-auto cardIcon">
                <div className="icon icon-shape bg-white text-dark rounded-circle shadow">
                    <i className="ni ni-hat-3 "></i>
                </div>
                </div>
            </div>
            <p className="mt-3 mb-1 text-sm text-center studentsSubj2">   
            {subject.isCoursePublish && (
            <LinkContainer to={`/studentwatchcourse/${subject.course}`} className='btn btn-default'>
                      <Button variant={classButton}> &nbsp; Watch Lessons &nbsp;</Button>
            </LinkContainer>
            )}
              <LinkContainer to={`/studentpreviousanswers/${subject._id}`} className='btn btn-default'>
                      <Button variant={classButton}> &nbsp;  Questions </Button>
              </LinkContainer>              
            </p>           
        </div>
      </div>
   </div>
  )
}

export default StudentSubject
